export default function decrementId(ary, value) {
  const index = ary.findIndex(item => item.id === value);
  if (index > 0) {
    return ary[index - 1].id;
  } else {
    return ary[ary.length - 1].id;
  }
}